import React, { ReactElement, useState } from 'react';
import { Button, Col, Modal, Row } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import PolicyCard from '../cards/BeneficiaryCard/policyCard';
import { FILTER_KEY_FOR_COVERAGE, FILTER_KEY_FOR_IPO, GUTTOR_SPACE, PASSWORD_NOT_VERIFIED_ERROR } from '../../../../../../shared/constants/commonConstants';
import { RootState } from '../../../../../../store';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { getIPODetails, setCardChanged, setCoverageId, setIPOId, setPayerDropDownVisible, setSelectedPolicyDetail } from '../../../../../../store/actions/nhcxAction';
import {
  benefSearch, setAdmissionForm, setBeneficiaryList, setbillAmountArray, setClassificationArray,
  setIsAbhaVerified, setIsShowAdmissionForm, setSelectedBeneficiary, setSelectedTab, setUploadedFiles,
  toggleOtherProcedure, updatePackageSelection,
} from '../../../../../../store/actions/newAdmissionAction';
import { cloneDeep, isEmpty } from 'lodash';
import { DEFAULT_ADMISSION_FORM_VALUE, SELECT_RIGHT_POLICY } from '../../../../../../shared/constants/crmConstants';
import { setClaimData } from '../../../../../../store/actions/claimDetailsAction';
import { Payer } from '../../../../../../shared/models/payer.model';
import { changePayer } from '../../../../../../store/actions/payerListAction';
import { centeredNotification } from '../../../../../../utils/utility';
import { MailboxType } from '../../../../../../store/models/mailBoxModel';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';

const PolicySearchCards = ({
  dataFound, completeStep, resetStep, resetMultipleSteps,
  policyLoading, selectedOption }: any): ReactElement => {
  const dispatch = useDispatch();
  const { policySearchList, selectedPolicyDetail, cardChanged } = useSelector((state: RootState): NHCXState => state.nhcx);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [tempPolicyDetail, setTempPolicyDetail] = useState<any>(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [confirmedPolicyDetail, setConfirmedPolicyDetail] = useState<any>(null);
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const { payerConfiguration: payerConfig = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { isDraftSelected } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { payers } = payerConfig || {};

  const onClick = (selected: any): any => {
    if (policySearchList?.length > 0 && selected !== selectedPolicyDetail) {
      resetMultipleSteps(['memberSearch', 'PolicyCard', 'documentsAttached', 'claimReviewed', 'memberCard']);
      setIsConfirmModalVisible(true);
    } else {
      setIsConfirmModalVisible(false);
    }
    setTempPolicyDetail(selected);
  };

  const onIPOSucess = (data: any): void => {
    dispatch(setIPOId(data));
    setCardLoading(false);
  };
  const onIPOError = (): void => {
    setCardLoading(false);
  };

  const onCoverageSuccess = (data: any): any => {
    const memberCorelationId = data[0].memberCorelationId;
    dispatch(setCoverageId(memberCorelationId));
    setCardLoading(false);
  };
  const onCoverageError = (): void => {
    setCardLoading(false);
  };

  const closeModal = (): any => {
    setIsConfirmModalVisible(false);
    setCardLoading(false);
  };

  const initiateMemberForm = (): void => {
    dispatch(setBeneficiaryList([]));
    dispatch(setIsShowAdmissionForm(false));
    dispatch(setSelectedBeneficiary(null));
    dispatch(setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(setUploadedFiles([]));
    dispatch(setIsAbhaVerified(false, {}));
    dispatch(toggleOtherProcedure(false));
    dispatch(setClassificationArray([]));
    dispatch(setbillAmountArray([]));
    dispatch(setSelectedTab(-1));
    dispatch(setClaimData({}));
    dispatch(updatePackageSelection([]));
  };

  const prefillPayer = (selected?: any): any => {
    if (selected) {
      const payerDetail: Payer | undefined = configuredPayers.find(
        ({ uniqueIdentifier }: Payer): boolean => uniqueIdentifier === String(selected),
      );
      if (payerDetail && !isDraftSelected) {
        dispatch(changePayer(payerDetail));
        dispatch(setIsShowAdmissionForm(false));
        dispatch(setCardChanged(!cardChanged));
        const selectedPayer = payers?.find((item: any): any =>
          payerDetail?.id === item['payerID'],
        );
        if (payerDetail.isRpaPayer && (selectedPayer && selectedPayer?.isEnabled === false)) {
          centeredNotification(PASSWORD_NOT_VERIFIED_ERROR);
        }
      }
    }
  };

  const confirmCardSelection = (): any => {
    const formattedProductCode = tempPolicyDetail?.productId?.split('|')[0];
    tempPolicyDetail.productCode = formattedProductCode;
    setConfirmedPolicyDetail(tempPolicyDetail);
    setCardLoading(true);
    dispatch(setSelectedPolicyDetail(tempPolicyDetail));
    setIsConfirmModalVisible(false);
    prefillPayer(tempPolicyDetail?.payerId);
    const payload = {
      'isNHCXEnabledProvider': true,
      'isDirectFlow': false,
      'productId': tempPolicyDetail?.productId,
      'payerId': tempPolicyDetail?.payerId,
      'memberId': tempPolicyDetail?.memberId,
      'patientName': tempPolicyDetail?.memberName,
      'policyNumber': tempPolicyDetail?.policyNumber || undefined,
      'productName': tempPolicyDetail?.productName || undefined,
      'healthId': tempPolicyDetail?.abhaNo || undefined,
    };

    const filterForRoutingAPI = tempPolicyDetail?.nhcxEnabledRoutingApi;
    if (filterForRoutingAPI?.length && tempPolicyDetail?.nhcxEnabledPayerForProvider) {
      if (filterForRoutingAPI?.includes(FILTER_KEY_FOR_IPO)) {
        dispatch(getIPODetails(payload, onIPOSucess, onIPOError));
      }
      if (filterForRoutingAPI?.includes(FILTER_KEY_FOR_COVERAGE)) {
        dispatch(benefSearch(payload, onCoverageSuccess, onCoverageError));
      }
    } else {
      setCardLoading(false);
    }
    completeStep('policyCard');
    dispatch(setPayerDropDownVisible(true));
    initiateMemberForm();
  };

  if (!dataFound && !policyLoading && selectedOption === 'NHCX') {
    return <Row className="benef-text">
      <p>No NHCX policy found. Please verify the details or submit via Insurance</p>
    </Row>;
  }

  return (
    <>
      {!isEmpty(policySearchList) &&
        <Row gutter={GUTTOR_SPACE}>
          {policySearchList?.map((policyDetail: any, index: number): ReactElement => (
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8} key={index}
              onClick={(): void => !(policyDetail?.disabled) && (policyDetail !== selectedPolicyDetail)
                ? onClick(policyDetail) : undefined}>
              <PolicyCard
                isSelected={policyDetail === tempPolicyDetail}
                loading={cardLoading}
                policySearchResults={policyDetail}
                index={index}
                disabled={policyDetail?.disabled}
                isConfirmed={policyDetail === confirmedPolicyDetail}
              />
            </Col>
          ))}
          <Row className="policyOptionsDiv">
            <Modal
              visible={isConfirmModalVisible}
              onCancel={(): any => closeModal()}
              width={500}
              bodyStyle={{ marginTop: '50px' }}
              footer={[
                <Button key="close" type="default" onClick={(): any => {
                  closeModal();
                }}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={(): any => {
                  confirmCardSelection();
                }}>
                  Proceed
                </Button>,
              ]}
            >
              <div className="mt-md">{SELECT_RIGHT_POLICY}</div>
            </Modal>
          </Row>
        </Row>
      }
    </>
  );
};

export default PolicySearchCards;
